document.addEventListener("alpine:init", () => {
  Alpine.data(
    "shippingCountdown",
    ({ cutoffTime, enabled, enableFixedCountdown, fixedCountdownTime }) => {
      return {
        enabled: enabled,
        enableFixedCountdown: enableFixedCountdown || false,
        fixedCountdownTime: fixedCountdownTime || "18:31", // Format: "minutes:seconds"
        packingMessage: "Packed today",
        timeRemaining: "0m 0s",
        showCountdown: false,
        cutoffTime: cutoffTime,
        intervalId: null,
        totalSeconds: 0, // For fixed countdown

        init() {
          if (!this.enabled) return;

          if (this.enableFixedCountdown) {
            this.initFixedCountdown();
          } else {
            this.updateCountdown();
          }

          this.intervalId = setInterval(() => {
            if (this.enableFixedCountdown) {
              this.updateFixedCountdown();
            } else {
              this.updateCountdown();
            }
          }, 1000);
        },

        destroy() {
          if (this.intervalId) {
            clearInterval(this.intervalId);
          }
        },

        initFixedCountdown() {
          // Parse fixed countdown time (e.g., "18:31")
          const { minutes, seconds } = this.parseFixedCountdownTime(
            this.fixedCountdownTime
          );
          this.totalSeconds = minutes * 60 + seconds;

          // Set today's date message
          const today = new Date();
          this.packingMessage = `Packed today, ${this.formatDate(today)}`;
          this.showCountdown = true;

          // Initial display
          this.updateFixedCountdownDisplay();
        },

        updateFixedCountdown() {
          if (this.totalSeconds <= 0) {
            this.packingMessage = "Still available today – hurry!";
            this.showCountdown = false;
            return;
          }

          this.updateFixedCountdownDisplay();
          this.totalSeconds--;
        },

        updateFixedCountdownDisplay() {
          if (this.totalSeconds <= 0) {
            this.timeRemaining = "0m 0s";
            return;
          }

          const minutes = Math.floor(this.totalSeconds / 60);
          const seconds = this.totalSeconds % 60;

          this.timeRemaining = `${minutes}m ${
            seconds < 10 ? "0" : ""
          }${seconds}s`;
        },

        parseFixedCountdownTime(timeString) {
          // Parse time like "18:31" (minutes:seconds)
          const timeRegex = /^(\d{1,3}):(\d{2})$/;
          const match = timeString.trim().match(timeRegex);

          if (!match) {
            // Fallback to 18:31 if parsing fails
            return { minutes: 18, seconds: 31 };
          }

          const minutes = parseInt(match[1], 10);
          const seconds = parseInt(match[2], 10);

          return { minutes, seconds };
        },

        updateCountdown() {
          // Use customer's local time directly
          const now = new Date();
          const today = new Date(now);
          const tomorrow = new Date(today);
          tomorrow.setDate(tomorrow.getDate() + 1);

          // Parse cutoff time (e.g., "3:00 PM") and set it for today
          const { hours, minutes } = this.parseAmPmTime(this.cutoffTime);
          const cutoffToday = new Date(today);
          cutoffToday.setHours(hours, minutes, 0, 0);

          // Set cutoff for tomorrow
          const cutoffTomorrow = new Date(tomorrow);
          cutoffTomorrow.setHours(hours, minutes, 0, 0);

          if (now < cutoffToday) {
            // Before cutoff - show "packed today" with countdown
            this.packingMessage = `Packed today, ${this.formatDate(today)}`;
            this.showCountdown = true;
            this.calculateTimeRemaining(cutoffToday);
          } else {
            // After cutoff - show "packed tomorrow" with countdown to tomorrow's cutoff
            this.packingMessage = `Packed tomorrow, ${this.formatDate(
              tomorrow
            )}`;
            this.showCountdown = true;
            this.calculateTimeRemaining(cutoffTomorrow);
          }
        },

        calculateTimeRemaining(targetTime) {
          const now = new Date();
          const diff = targetTime - now;

          if (diff <= 0) {
            this.timeRemaining = "0m 0s";
            return;
          }

          const hours = Math.floor(diff / (1000 * 60 * 60));
          const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
          const seconds = Math.floor((diff % (1000 * 60)) / 1000);

          if (hours > 0) {
            this.timeRemaining = `${hours}h ${minutes}m ${seconds}s`;
          } else {
            this.timeRemaining = `${minutes}m ${seconds}s`;
          }
        },

        parseAmPmTime(timeString) {
          // Parse time like "3:00 PM" or "11:30 AM"
          const timeRegex = /^(\d{1,2}):(\d{2})\s*(AM|PM)$/i;
          const match = timeString.trim().match(timeRegex);

          if (!match) {
            // Fallback to 3:00 PM if parsing fails
            return { hours: 15, minutes: 0 };
          }

          let hours = parseInt(match[1], 10);
          const minutes = parseInt(match[2], 10);
          const period = match[3].toUpperCase();

          // Convert to 24-hour format
          if (period === "AM") {
            if (hours === 12) hours = 0; // 12 AM = 0 hours
          } else {
            // PM
            if (hours !== 12) hours += 12; // Add 12 for PM, except 12 PM stays 12
          }

          return { hours, minutes };
        },

        formatDate(date) {
          return date.toLocaleDateString("en-US", {
            month: "long",
            day: "numeric",
          });
        },
      };
    }
  );
});
